// extracted by mini-css-extract-plugin
export var dropdownContainer = "_kg-0";
export var leftAlign = "_kg-4";
export var listItem = "_kg-2";
export var listItemWrapper = "_kg-1";
export var operationText = "_kg-3";